import { memo, type PropsWithChildren } from 'react';

import { SWRConfig } from 'swr';

import { config } from './_config';

export default memo(({ children }: PropsWithChildren) => {
  return <SWRConfig value={config}>{children}</SWRConfig>;
});
